<template>
  <div class="fe-area-select" id="areaSelect">
    <el-form-item
      :label="endTitle | capitalize"
    >
      <el-select
        :placeholder="placeholder"
        collapse-tags
        multiple
        filterable
        ref="input"
        v-model="defaultValue"
        class="fe-area-select-content"
        :disabled="isDsiable"
        :loading="loading"
        @remove-tag="removeAll"
      >
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
        <el-option
          key="all"
          label="全部"
          value="all"
        >
        </el-option>
        <el-option
          v-for="item in options"
          :key="item.regionCode"
          :label="getLabel(item)"
          :value="item.regionCode">
        </el-option>
      </el-select>
    </el-form-item>
  </div>
</template>
<script>
  import baseMixin from '../mixin/base'
  import request from '@/utils/request'
  // import _ from 'lodash'
/* eslint-disable */
  export default {
    name: 'fe-area-select',
    mixins: [baseMixin],
    props: {
      path: {
        type: String,
        required: true
      },
      level: {
        type: Number
      },
      params: {
        type: Object
      },
      target: {
        type: Array
      },
      labelName: {
        type: String
      },
      show: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        defaultValue: [],
        loading: false,
        options: [],
        isDsiable: true
      }
    },
    beforeMount() {
      if (this.show) {
        this.getData()
      }
    },
    watch: {
      value: {
        handler(val) {
          if (process.env.PROJECT === 'bi') {
            if(val.length>0){
              this.$el.getElementsByClassName("is-medium")[0].style.display='none';
            }else{
              this.$el.getElementsByClassName("is-medium")[0].style.display='block';
            }
          }
          this.defaultValue = val
        },
        deep: true
      },
      defaultValue(val) {
        if (~val.indexOf('all')) {
          const allValue = []
          this.options.forEach((item) => {
            allValue.push(item.regionCode)
          })
          this.$emit('input', allValue)
        } else {
          this.$emit('input', val)
        }
      },
      options: {
        handler(val) {
          if (val.length > 0) {
            this.isDsiable = false
          } else {
            this.isDsiable = true
          }
        }
      },
      params: {
        handler(val) {
          // this.getData()
        },
        immediate: false,
        deep: true
      }
    },
    methods: {
      removeAll() {
        this.defaultValue = []
      },
      getLabel(item) {
        return item[this.labelName]
      },
      getData(event) {
        if (!this.show) {
          return
        }
        this.loading = true
        const dataParams = _.merge({}, this.params, { level: this.level }, this.$route.query)
        request({
          url: this.path,
          method: 'post',
          data: dataParams
        }).then((res) => {
          this.loading = false
          if (res.code === 0) {
            this.options = res.data
          } else {
            this.$message.error('获取地区数据错误')
          }
        })
      }
    }
  }
</script>
<style type="text/scss" lang="scss">
  .fe-area-select {
    margin-top: 5px;
    margin-bottom: 5px;
    width:298px;
    .el-form-item {
      margin-bottom: 0px;
      .el-form-item__label {
        font-size: 12px!important;
      }
      &.s-required{
        &::before{
          content: "*";
          color: #f56c6c;
          margin-right: 4px;
          position: absolute;
          bottom: 5px;
          left:0;
        }
      }
    }
    label {
      font-size: 12px!important;
      width: 100px;
      line-height: 30px;
      display: inline-block;
    }
    .fe-area-select-content {
      width: 178px;
      max-width: 178px !important;
      .el-select__tags{
        z-index: 2!important;
        margin-left:25px;
        height: 100%;
        input{
          /*// left: 10px;*/
          /*margin-left: 0px;*/
          max-width: 178px !important;
        }
        span:first-child{
          display: inline-flex;
        }
        .el-tag{
          //margin-top:29px;
          &:first-child{
            overflow: hidden;
            max-width: 70px !important;
            text-overflow: ellipsis;
            z-index:2;
            .el-select__tags-text{
              display: inline-flex;
              max-width:36px;
              text-overflow: ellipsis;
              overflow: hidden;
            }
            .el-tag__close{
              top:5px !important;
              right:-3px;
            }
          }
        }
      }
      .el-input{
        .el-input__prefix{
          position: relative;

          .el-input__icon{
            position: absolute;
            z-index: 1;
            left: -178px;

          }
        }
      }
      .el-tag--small{
        padding: 0 5px;
      }
    }
  }
  .el-select__input{
    position: relative;
    left: 15px;
  }
  #areaSelect{
    .el-input__inner{
      height:36px !important;
      overflow:hidden !important;
    }
    .el-input__icon{
      width:20px !important;
    }
    .is-medium{
      position: absolute;
      padding-top:4px;
      left: -12px;
      z-index:1;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/FromBase/area/areaSelect.vue